import { panelNumeric } from './tpl/panelNumeric.js'
import { panelRefinement } from './tpl/panelRefinement.js'

/**
 * Creates widget instances from a collection of container elements.
 * Each container element should have data attributes specifying the widget configuration.
 *
 * @param {Array} widgetContainers - An array of DOM elements that will act as containers for widgets.
 * @returns {Array} An array of initialized widget instances.
 *
 * The function iterates over each container in `widgetContainers` and uses the data attributes
 * to determine the type of widget to create and its configuration. Currently supports 'numeric'
 * and 'refinement' widget types. Parses the `items` data attribute as JSON to pass as an argument
 * to the widget creation functions. Filters out any null values to ensure only valid widgets are returned.
 *
 * @example
 * // Usage example within an Algolia InstantSearch setup:
 * const widgetContainers = Array.from(document.querySelectorAll('[data-widget-auto]'));
 * const widgetInstances = createWidgetInstances(widgetContainers);
 *
 *
 * // Adding the created widgets to the search instance
 * search.addWidgets([...widgetInstances]);
 */

export function createWidgetInstances(widgetContainers) {
  return widgetContainers
    .map((container) => {
      const {
        widgetAuto: type,
        title,
        label: lbl,
        attribute,
        items: its,
      } = container.dataset

      const label = lbl || title || attribute
      let items

      try {
        items = JSON.parse(its || '[]')
      } catch (e) {
        console.error(`Error parsing JSON data for widget: ${e}`)
        items = [] // Default to an empty array if parsing fails
      }

      if (type === 'numeric') {
        return panelNumeric(container, attribute, label, items)
      }
      if (type === 'sortNumber') {
        return panelRefinement(container, attribute, label, { sort: 'number' })
      }
      if (type === 'refinement') {
        return panelRefinement(container, attribute, label)
      }
      console.error(`Unknown widget type: ${type}`)
      return null
    })
    .filter((widget) =>
      widget !== null)
}
